import {
  Component,
  Input,
  Output,
  OnInit,
  OnChanges,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { ModalController, ActionSheetController } from '@ionic/angular';
import { Client } from '../../models';
import { Utilities } from '../../utilities/utilities';
import { ClientFormPageComponent } from '../client-form-page/client-form-page.component';
import { CardOnFileComponent } from '../card-on-file/card-on-file.component';

import { StripePayment, StripeService } from '../../services/stripe.service';
import { UserService } from '../../services/user.service';

import { ENV_CONFIG } from '../../../bin/env.config';

declare var Stripe: stripe.StripeStatic;

export interface IClientFormCallBackData {
  client: Client;
  // save or delete
  action: string;
}

@Component({
  selector: 'smr-client-info',
  templateUrl: 'client-info.component.html',
})
export class ClientInfoComponent implements OnInit, OnChanges {
  @Input() client: Client;
  @Input() isReadOnly: boolean = false;
  @Output() onClientUpdate = new EventEmitter<IClientFormCallBackData>();
  @Input() hidePermanentNote: boolean = false;
  public showClientContactDetails: boolean;
  public showClientLocationData: boolean;
  public hasStripeAccount: boolean =  this.userService.getSalon().hasStripeAccount();
  public stripe;
  public stripeInfoIsFetched: boolean = false;
  public stripeAccountInfo: Array<StripePayment>;
  public clientHasStripeID: boolean = false;
  public card;
  public cardOnFile;
  public cardErrors;
  public errorMessage;
  public paymentInfo;
  public paymentMethodID: string;
  public cardInfo = {
    brand: '',
    last4: '',
    exp_month: '',
    exp_year: '',
    funding: '',
    paymentMethodID: '',
  };
  public loadingCardData: boolean = true;

  constructor(
    private ref: ChangeDetectorRef,
    private modalCtrl: ModalController,
    private stripeService: StripeService,
    private userService: UserService,
    private actionSheetController: ActionSheetController
  ) {}

  public ngOnInit() {
      }

  public ngOnChanges() {
    if (this.client) {
      this.showClientContactDetails = Utilities.clientHasContactDetails(
        this.client
      );
      this.showClientLocationData = Utilities.clientHasLocationData(
        this.client
      );
    }

    this.loadCardData();
  }

  public async edit() {
    const modal = await this.modalCtrl.create({
      component: ClientFormPageComponent,
      componentProps: {
        client: this.client,
        modal: true,
        saveButtonText: 'Save & Continue',
      },
    });

    modal.present();

    modal.onWillDismiss().then((data) => {
      if (data.data) {
        this.onClientUpdate.emit(data.data);
      }
    });
  }

  public async loadCardData() {
    this.loadingCardData = true;
    if (this.client) {
      this.showClientContactDetails = Utilities.clientHasContactDetails(
        this.client
      );
      this.showClientLocationData = Utilities.clientHasLocationData(
        this.client
      );
      //TODO check if salon has a stripe ID
      this.stripeService
        .getClientStripeID({ clientID: this.client.id })
        .subscribe((clientStripeIDResponse) => {
          this.clientHasStripeID = !!clientStripeIDResponse;

          this.cardOnFile = false;
          if (this.clientHasStripeID) {
            this.stripeService
              .getCustomerCardInfo({ clientID: this.client.id })
              .subscribe({
                next: (cardInfo) => {
                  if (cardInfo) {
                    this.cardInfo = cardInfo;
                    this.paymentMethodID = this.cardInfo.paymentMethodID;
                    this.cardOnFile = true;
                  }
                },
                error: (error) => {
                },
              });
          }
          this.loadingCardData = false;
        });
    }
  }

  async addCardOnFile(isCardChange = false) {
    // let client: Client = new Client();
    // client = client.setStylistID(this.userService.getUser().getID());
    const cardOnFileModal = await this.modalCtrl.create({
      component: CardOnFileComponent,
      componentProps: {
      client: this.client,
      clientHasStripeID: this.clientHasStripeID,
      modal: true,
    }});

    cardOnFileModal.onWillDismiss().then((data) => {
      if (data.data) {
        if (data.data === true) {
          this.loadCardData();
        }
      }
    });

    cardOnFileModal.present();
  }

  async removeCardOnFile() {
    const actionSheet = await this.actionSheetController.create({
      header: `Are you sure you want to delete this card?`,
      buttons: [
        {
          text: `Yes, delete this card`,
          role: 'destructive',
          handler: () => {
            this.stripeService
              .detachPaymentMethod({
                paymentMethodID: this.cardInfo.paymentMethodID,
              })
              .subscribe({
                next: (result) => {
                  this.ref.detectChanges();
                  this.loadCardData();
                  actionSheet.dismiss();
                },
                error: (error) => {
                },
              });
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
          // icon: 'close',
          handler: () => {
            actionSheet.dismiss();
            return false;
          },
        },
      ],
    });

    actionSheet.present();
  }
}
